import { ItemsStateWithPagination } from 'pagination';
import { DataViewSortingType } from 'api/LoanOriginationSystem/Types';

export enum NormalizedStatus {
  Active = 'Active',
  Archive = 'Archive',
  Inactive = 'Inactive',
  Testing = 'Testing',
  Unknown = 'Unknown',
}

export type SystemStatus = 'active' | 'testing' | null | 'archive';

export type StrategiesList = Partial<Record<string, Strategy>>;

export interface DecisionStrategiesState extends ItemsStateWithPagination<Strategy> {
  searchInputValue: string;
  strategiesDetailedAttributes: StrategiesList;
  strategiesRecoveryCopy?: StrategiesList;
  isLoading: boolean;
  blockingActionInProgress: boolean;
  searched: {
    [searchInputValue: string]: ItemsStateWithPagination<Strategy>;
  };
  collapsedModules: { [strategyId: string]: boolean[] };
}

export interface Strategy {
  id: string;
  name: string;
  version: number;
  versionsCount: number;
  status: NormalizedStatus;
  isLocked: boolean;
  editorFirstName: string;
  editorLastName: string;
  editorImageId?: string;
  updated: Date;
  description: string;
  latestVersion: boolean;
  moduleList: StrategyModule[];
}

export enum ModuleType {
  RequirementsRules = 'requirements',
  CalculationScripts = 'calculations',
  RuleBasedOutputs = 'output',
  SimpleOutputs = 'assignments',
  ScoringModel = 'scorecard',
  ExternalIntegration = 'dataintegration',
  ImportExistingModule = 'ImportExistingModule',
}

export interface StrategyModule {
  id: string;
  active: boolean;
  description: string;
  name: string;
  lookupName: string;
  branches: ModuleBranch[];
  type: ModuleType;
  moduleId: string;
}

export interface ModuleBranch {
  id: string;
  name: string;
  description: string;
}

export enum ApiActivationSortingFields {
  StrategyName = 'strategyName',
}

export interface DropdownStrategy {
  id: string;
  status: SystemStatus;
  version: number;
  name: string;
  title: string;
}

export type ApiActivationSortingType = DataViewSortingType<ApiActivationSortingFields>;
